import React, { useEffect, useState } from 'react';
import { Paper, ClickAwayListener, Popper, Grow, MenuList, IconButton } from '@material-ui/core';


export default function MenuDropdown(props) {
  const { icon, anchorRef } = props;

  const [menuOpen, setMenuOpen] = useState(false);
  const prevOpen = React.useRef(menuOpen);

  useEffect(() => {
    if (prevOpen.current === true && menuOpen === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = menuOpen;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuOpen]);

  function handleMenuToggle() {
    setMenuOpen((prevOpen) => !prevOpen);
  }

  function handleMenuClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setMenuOpen(false);
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setMenuOpen(false);
    }
  }

  return (<>
    <IconButton
      ref={anchorRef}
      edge="start"
      // className={classes.menuButton}
      color="inherit"
      aria-label="menu"
      aria-controls={menuOpen ? 'menu-list' : undefined}
      aria-haspopup="true"
      onClick={handleMenuToggle}
    >
      {icon}
    </IconButton>
    <Popper
      open={menuOpen}
      anchorEl={anchorRef.current}
      transition
      style={{ zIndex: 999 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleMenuClose}>
              <MenuList autoFocusItem={menuOpen} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                {props.children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  </>);
}
